import Container from '@/components/base/Container';
import SectionLabel from '@/components/base/SectionLabel';

interface PageHeaderProps {
  index: string;
  label: string;
  title: string;
  intro: string;
  letter: string;
}

export default function PageHeader({ index, label, title, intro, letter }: PageHeaderProps) {
  return (
    <header className="paper-texture relative overflow-hidden pb-16 pt-32 md:pb-24 md:pt-44">
      <span
        aria-hidden="true"
        className="pointer-events-none absolute -right-4 -top-6 select-none font-poster text-[180px] font-extrabold leading-[0.8] text-primary-500/90 mix-blend-multiply md:right-10 md:text-[320px]"
      >
        {letter}
      </span>
      <Container>
        <SectionLabel index={index} label={label} />
        <div className="mt-10 grid grid-cols-1 gap-8 md:mt-16 lg:grid-cols-12 lg:gap-6">
          <h1 className="font-heading text-4xl font-light leading-[1.05] tracking-[-0.02em] text-foreground-950 md:text-6xl lg:col-span-8 lg:text-[72px]">
            {title}
          </h1>
          <p className="max-w-md text-[15px] leading-relaxed text-foreground-700 md:text-base lg:col-span-4 lg:self-end">
            {intro}
          </p>
        </div>
      </Container>
    </header>
  );
}